/* globals __DEV__ $Keys */
import { APP_ACTION_TYPES, APP_LIFECYCLE_STATE } from './constants';

import type { Action, Dispatch } from '../types';
import type { TabKey, ReceiveSetActiveTabPayload } from './types';

export function setActiveTab(tab: TabKey): (dispatch: Dispatch) => Promise<Action<ReceiveSetActiveTabPayload>> {
  return async dispatch => {
    dispatch({
      type: APP_ACTION_TYPES.SET_ACTIVE_TAB
    });
    try {
      return dispatch({
        type: APP_ACTION_TYPES.RECEIVE_ACTIVE_TAB,
        payload: {
          tab
        }
      });
    }
    catch (error) {
      return dispatch({
        type: APP_ACTION_TYPES.RECEIVE_ERROR,
        payload: {
          error
        }
      });
    }
  };
}

export function handleException(error: Error): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: APP_ACTION_TYPES.RECEIVE_ERROR,
      payload: {
        error
      }
    });
  };
}

export function receiveAppStateChange(appState: $Keys<typeof APP_LIFECYCLE_STATE>): (dispatch: Dispatch) => void {
   return (dispatch: Dispatch) => {
    dispatch({
      type: APP_ACTION_TYPES.RECEIVE_APP_LIFECYCLE_STATE,
      payload: {
        appState
      }
    });
   };
}



// WEBPACK FOOTER //
// ./src/redux/app/actions.js